import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { toggleLanguage, useDirection } from "../lib/direction";

/**
 * The single language switcher. It replaces four different ones that had
 * drifted apart across the pages: an outlined button, a hand-drawn SVG
 * ticket, and two differently styled rounded buttons.
 */
export default function LangToggle() {
  const { t } = useTranslation();
  const { isRtl } = useDirection();

  return (
    <Button
      type="button"
      outlined
      icon="pi pi-globe"
      /* The label always names the language being switched *to*, written in
         that language, so it reads correctly whichever way round you are. */
      label={isRtl ? "English" : "العربية"}
      aria-label={t("ui.switchLanguage")}
      onClick={toggleLanguage}
      className="p-button-sm"
    />
  );
}
